module.exports = __webpack_public_path__ + "static/media/icon_user_bg.6d316615.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/portfolio/assets/icon_user_bg.png
// module id = 2249
// module chunks = 2